import React from 'react';
import styled from 'styled-components';
import { Icon } from 'scorer-ui-kit';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled.span`
  text-align: justify;
  margin-left: 11px;
  opacity: 0.76;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-weight: 500;
  letter-spacing: 0.34px;
  color: #575757;
  white-space: nowrap;

  @media screen and (min-height: 800px) { 
    font-size: 12px;
  }
  @media screen and (max-height: 799px) { 
    font-size: 16px;
  }
`;

const Button = styled.button`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 16px;
  font-weight: 500;
  padding: 20px;
  background-color: unset;
  border: none;
  outline: none;
  cursor: pointer;
  display:flex;
  flex-direction: row;
  border-top: 1px solid;
  align-items: center;
`;

interface IProps {
  onLanguageToggle?: () => void;
}


const LanguageSwitch: React.FC<IProps> = ({ onLanguageToggle = () => { } }) => {
  return (
    <Container>
      <Button onClick={onLanguageToggle}>
        <Icon icon='Language' color='dimmed' size={24} />
        <Text>LANGUAGE/日本語</Text>
      </Button>
    </Container>
  );
};

export default LanguageSwitch;
